(function () {
  var mq = window.matchMedia('(max-width: 749px)');

  function setupSection(section) {
    if (section.hasAttribute('data-et-mc-init')) return;
    section.setAttribute('data-et-mc-init', '');

    var el = section.querySelector('.et-mc__swiper');
    if (!el) return;
    var dots = section.querySelector('.et-mc__dots');
    var instance = null;

    function update() {
      if (mq.matches && !instance) {
        // slidesPerView 'auto': slide width comes from CSS (.et-mc__item),
        // never from measuring the container — immune to bogus width calc.
        instance = new Swiper(el, {
          slidesPerView: 'auto',
          spaceBetween: 12,
          pagination: dots ? { el: dots, clickable: true } : undefined
        });
      } else if (!mq.matches && instance) {
        instance.destroy(true, true);
        instance = null;
      }
    }

    if (mq.addEventListener) {
      mq.addEventListener('change', update);
    } else if (mq.addListener) {
      mq.addListener(update);
    }
    update();
  }

  function initAll(root) {
    whenSwiperReady(function () {
      (root || document).querySelectorAll('.et-mc').forEach(setupSection);
    });
  }

  function whenSwiperReady(callback) {
    if (typeof Swiper !== 'undefined') {
      callback();
      return;
    }
    var attempts = 0;
    var timer = setInterval(function () {
      attempts += 1;
      if (typeof Swiper !== 'undefined') {
        clearInterval(timer);
        callback();
      } else if (attempts > 100) {
        clearInterval(timer);
      }
    }, 50);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.classList && event.target.classList.contains('et-mc')) {
      whenSwiperReady(function () {
        setupSection(event.target);
      });
    } else if (event.target.querySelector('.et-mc')) {
      initAll(event.target);
    }
  });
})();
